import { render } from "./SearchModal.vue?vue&type=template&id=50d9e5d6"
import script from "./SearchModal.vue?vue&type=script&lang=ts"
export * from "./SearchModal.vue?vue&type=script&lang=ts"

import "./SearchModal.vue?vue&type=style&index=0&id=50d9e5d6&lang=scss"
script.render = render

export default script